import React from "react";
import { NewItemsNotificationBanner } from "@/components/ui/NewItemsNotificationBanner";

interface UnifiedItemsNotificationProps {
  newItemCount: number;
  itemLabel: string;
  onRefresh: () => Promise<void>;
  onDismiss: () => void;
}

/**
 * Notification banner for new items added by other users
 * Shows when real-time sync detects new items
 */
export function UnifiedItemsNotification({
  newItemCount,
  itemLabel,
  onRefresh,
  onDismiss,
}: UnifiedItemsNotificationProps) {
  if (newItemCount <= 0) {
    return null;
  }

  return (
    <div className="px-4 pt-4">
      <NewItemsNotificationBanner
        newItemCount={newItemCount}
        itemLabel={itemLabel}
        onRefresh={onRefresh}
        onDismiss={onDismiss}
      />
    </div>
  );
}
